<template>
	<ul class="course-list" v-if="courseData.length">
		<li v-for="(item, index) in courseData" :key="index" @click="goDetail(item)">
			<div class="course-img">
				<van-image class="img" :src="item.bookimage"></van-image>
			</div>
			<div class="course-infs">
				<div class="course-name font34">{{ item.name }}</div>
				<div class="course-author-unit font24 df-mc">
					<!-- {{ item.userunit }}/{{ item.unit }}单元 {{ item.usersection }}/{{ item.section }}节 -->
					{{ item.unit }}单元 {{ item.section }}节
				</div>
			</div>
			<div class="bnt df-mc font24 mCf">前往学习</div>
		</li>
	</ul>
</template>

<script>
import { setSourceUrl, setQuestion, removeSpace } from '@/utils/public';
export default {
	name: 'courseList',
	props: {
		courseData: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	data() {
		return {
			setQuestion: setQuestion
		};
	},
	created() {
		console.log(this.courseData);
	},
	methods: {
		setSourceUrl,
		removeSpace,
		goDetail(item) {
			let path = '/textbook';
			this.$router.push({
				path: path,
				query: {
					bookid: item.id,
					title:item.name
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.course-list {
	li {
		width: 100%;
		margin-bottom: 0.24rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background-color: var(--main-color-f);
		padding: 0.24rem;
		border-radius: 0.1rem;
		.course-img {
			width: 1.38rem;
			height: 1.85rem;
			margin-right: 0.26rem;
			overflow: hidden;
			.img {
				width: 100%;
				height: 100%;
			}
		}
		.course-infs {
			flex: 1;
			display: flex;
			justify-content: center;
			flex-direction: column;
			margin-right: 0.2rem;
			.course-name {
				width: 100%;
				font-size: 0.28rem;
				font-weight: 500;
				color: #333;
				margin-bottom: 0.3rem;
			}
			.course-author-unit {
				font-weight: 400;
				height: 0.45rem;
				color: #7c7c7c;
				background: #f8f8f8;
				border-radius: 0.04rem;
			}
		}
		.bnt {
			width: 1.52rem;
			height: 0.52rem;
			background: #ff7a32;
			border-radius: 0.26rem;
		}
	}
}
</style>
